import { useEffect, useState } from 'react';
import tarificar from '../services/tarificar';
import { COVERAGE_IDS, PLAN_ID } from '../utils/constanst';

const useCustomTarificarVSP = data => {

    const [ tarifas, setTarifas ] = useState(null);
    const [ loading, setLoading ] = useState(false);

    let obj = {
        "coverageIds": `${COVERAGE_IDS}`,
        edad: `${data.edad}`,
        imc: '25',
        'nCigar': '0',
        'suma': `${data.suma}`,
        'catactiv': `${data.catactiv}`,
        'inmo': 'U$',
        'inme': '2500'
    }

    for (let index = 1; index < 12; index++) {
        obj[`csi${index}`] = '0';
        obj[`cno${index}`] = '1';
    }   

    const tarificarPlan = tarificar(PLAN_ID);   

    const callAPI = async uri => { 
        setLoading(true);
        const resp = await  tarificarPlan(obj);     
        setTarifas(resp.rates); 
        setLoading(false);

    };

    useEffect(() => {

        if(data.edad != '' && data.catactiv != '0' ) 
            callAPI();
       
    }, [data.edad, data.suma, data.catactiv]);
    

    return { tarifas, loading }

}

export default useCustomTarificarVSP;
